export default __webpack_public_path__ + "static/media/Frame.f1f12baf.png";